export default __webpack_public_path__ + "static/photo-florent-goumy-bd216d41f8718304188e7abf06542bb1.webp";